"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function ResetIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M23.853,13.291l-2.934-2.933A9.053,9.053,0,0,0,3,11.158L1.349,9.507l-1.2,1.2,2.974,2.973a9.054,9.054,0,0,0,17.91-.808l1.62,1.619ZM12.017,19.359A7.368,7.368,0,0,1,4.836,13.59l2.881-2.881-1.2-1.2L4.692,11.33a7.355,7.355,0,0,1,14.5-.947l-2.909,2.908,1.2,1.2,1.859-1.859A7.365,7.365,0,0,1,12.017,19.359Z" })));
}
exports.default = ResetIcon;
